export const DEPARTMENT_ACCOUNTS = 'DEPARTMENT_ACCOUNTS';
